<template>
  <div>
    <!-- When countryIsTN is true, show dropdown with Arabic and French -->
    <a-dropdown v-if="countryIsTN">
      <template #overlay>
        <a-menu :selectedKeys="[]" @click="handlePDFLanguageSelection">
          <a-menu-item key="1">
            {{ $t("language.ar") }}
          </a-menu-item>
          <a-menu-item key="2">
            {{ $t("language.fr") }}
          </a-menu-item>
        </a-menu>
      </template>
      <a-button :loading="loading" :disabled="loading">
        <a-icon v-if="!loading" type="file-pdf" />{{
          $t("emploi.imprimerEmploiAdministrative")
        }}
      </a-button>
    </a-dropdown>

    <!-- When countryIsTN is false, show normal button that uses current locale -->
    <a-button
      v-if="!countryIsTN"
      :loading="loading"
      :disabled="loading"
      @click="generatePDFByCurrentLocale"
    >
      <a-icon v-if="!loading" type="file-pdf" />{{
        $t("emploi.imprimerEmploiAdministrative")
      }}
    </a-button>
  </div>
</template>
<script>
import apiClient from "@/services/axios";
import { mapState } from "vuex";
import JsPDF from "jspdf";
import "jspdf-autotable";
export default {
  name: "adminPDFschedule",
  props: ["trimester"],
  computed: {
    ...mapState(["settings", "user"]),
    countryIsTN() {
      const building = this.user.building.filter(
        (el) => el.dbName == this.settings.activeBuilding
      )[0] || {};
      return building.countryCode == "TN";
    },
  },
  methods: {
    handlePDFLanguageSelection(val) {
      if (val.key == "1") this.generateAdminPDF("ar");
      else this.generateAdminPDF("fr");
    },
    generatePDFByCurrentLocale() {
      // Generate PDF based on current i18n locale
      const currentLocale = this.$i18n.locale;
      // Map i18n locale to PDF language
      let pdfLang = "fr"; // default to French
      if (currentLocale === "ar-AR") {
        pdfLang = "ar";
      } else if (currentLocale === "en-US") {
        pdfLang = "en";
      } else if (currentLocale === "sw-KE") {
        pdfLang = "sw";
      } else if (currentLocale === "fr-FR") {
        pdfLang = "fr";
      }
      this.generateAdminPDF(pdfLang);
    },
    async getData() {
      await apiClient
        .post("/schedules/filter", {
          query: {
            status: { $ne: "inactive" },
            // Removed trimester filter to get all active sessions
          },
        })
        .then(({ data }) => {
          // First, filter out canceled sessions and process data structure
          const processedData = data
            .filter((sched) => !sched.canceled) // Filter out canceled sessions
            .map((sched) => {
              // Handle new data structure - use moduleGeneral if available, otherwise subject
              if (sched.moduleGeneral && sched.moduleGeneral._id) {
                sched.subject = sched.moduleGeneral;
              }
              // Ensure subject exists for display
              if (!sched.subject && !sched.moduleGeneral) {
                sched.subject = { name: sched.name || "Unknown Subject" };
              }

              return sched;
            });

          // Deduplicate based on unique session identifier
          const uniqueSessions = new Map();
          processedData.forEach((sched) => {
            const sessionKey = `${sched._id}_${sched.day}_${sched.time}_${
              sched.classeRoom?._id || "unknown"
            }`;
            if (!uniqueSessions.has(sessionKey)) {
              uniqueSessions.set(sessionKey, sched);
            }
          });

          this.data = Array.from(uniqueSessions.values());
        });
    },
    getPosition(time) {
      // Map a time within the hour to a 15-minute slot index (0,1,2,3)
      let position = time.split(":")[1];
      return Number(position / 15);
    },

    availableRow(row, position, durationSlots) {
      // Check availability for a given number of 15-minute slots
      for (let i = position; i < position + durationSlots; i++)
        if (row[i] !== null) return false;
      return true;
    },

    async generateAdminPDF(lang = "fr") {
      this.$gtag.event("Imp Emploi admin", {
        event_category: "Impression PDF",
        event_label: "Emploi - classe section",
        value: 1,
      });

      this.loading = true;

      // helper function to get translations in target language
      const getTranslation = (key, params = {}) => {
        // Map lang to i18n locale
        const localeMap = {
          ar: "ar-AR",
          fr: "fr-FR",
          en: "en-US",
          sw: "sw-KE",
        };
        const targetLocale = localeMap[lang] || "fr-FR";

        // Get translation from i18n messages without changing global locale
        try {
          const messages = this.$i18n.messages[targetLocale];
          const keys = key.split(".");
          let value = messages;
          for (const k of keys) {
            value = value?.[k];
          }

          // Replace parameters in the translation
          if (typeof value === "string" && params) {
            return value.replace(/\{(\w+)\}/g, (match, paramKey) => {
              return params[paramKey] !== undefined ? params[paramKey] : match;
            });
          }

          return value || key;
        } catch (e) {
          return key;
        }
      };

      await this.getData();
      let arrayOfImages = this.settings.image;
      for (var i = 0; i < arrayOfImages.length; i++) {
        if (this.settings.activeBuilding === arrayOfImages[i].db) {
          var imgData = new Image();
          imgData.src = arrayOfImages[i].logo;
        }
      }
      var doc = new JsPDF("landscape");
      const pdfWidth = doc.internal.pageSize.getWidth();

      doc.setFont("Amiri");

      // Position logo on left for Arabic (RTL), right for other languages (LTR)
      const logoWidth = 30;
      const logoHeight = 30;
      const logoX = lang === "ar" ? pdfWidth - (logoWidth + 8) : 8;
      doc.addImage(imgData, "JPEG", logoX, 5, logoWidth, logoHeight);

      doc.setFont("Amiri");
      doc.setFontSize(15);
      var today = new Date();
      const options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      };

      doc.setFontSize(10);

      // Format date based on language
      let formattedDate;
      if (lang === "ar") {
        formattedDate = today
          .toLocaleDateString("ar-TN", options)
          .replace(/،/g, "");
      } else if (lang === "en") {
        formattedDate = today.toLocaleDateString("en-US", options);
      } else if (lang === "sw") {
        formattedDate = today.toLocaleDateString("sw-KE", options);
      } else {
        formattedDate = today.toLocaleDateString("fr-FR", options);
      }

      // Position date text based on language direction
      const dateX = lang === "ar" ? 10 : pdfWidth - 10;
      const dateAlign = lang === "ar" ? "left" : "right";
      doc.text(
        dateX,
        10,
        getTranslation("emploi.pdfImprime", { date: formattedDate }),
        { align: dateAlign }
      );

      doc.setFontSize(lang == "ar" ? 20 : 18);
      doc.setFont("Amiri");

      // Use translation for title
      const title = getTranslation("emploi.pdfEmploiAdmin");
      const titleWidth = doc.getTextWidth(title);
      doc.text(pdfWidth / 2 - titleWidth / 2, 25, title);

      // Get translated day names
      const days = [
        getTranslation("days.monday"),
        getTranslation("days.tuesday"),
        getTranslation("days.wednesday"),
        getTranslation("days.thursday"),
        getTranslation("days.friday"),
        getTranslation("days.saturday"),
      ];

      const times = [
        "8:00",
        "9:00",
        "10:00",
        "11:00",
        "12:00",
        "13:00",
        "14:00",
        "15:00",
        "16:00",
        "17:00",
        "18:00",
      ];

      // Filter sessions for current week and next week (for A/B week sessions)
      const currentDate = new Date();
      const startOfWeek = new Date(currentDate);
      startOfWeek.setDate(currentDate.getDate() - currentDate.getDay() + 1); // Monday
      startOfWeek.setHours(0, 0, 0, 0);

      const endOfWeek = new Date(startOfWeek);
      endOfWeek.setDate(startOfWeek.getDate() + 6); // Sunday
      endOfWeek.setHours(23, 59, 59, 999);

      // Filter sessions for current week + biweekly sessions
      const filteredSchedules = this.data.filter((sched) => {
        // Handle both new Date format and legacy numeric format for day
        let sessionDate;
        if (sched.day instanceof Date) {
          sessionDate = new Date(sched.day);
        } else if (typeof sched.day === "string") {
          sessionDate = new Date(sched.day);
        } else {
          // Legacy format: day is a number (0-6), calculate date for current week
          const dayOfWeek = sched.day;
          sessionDate = new Date(startOfWeek);
          sessionDate.setDate(startOfWeek.getDate() + dayOfWeek);
        }

        // Check if session is within current week
        const isInCurrentWeek =
          sessionDate >= startOfWeek && sessionDate <= endOfWeek;

        // Include regular sessions (no week specified) for current week
        if (!sched.week && isInCurrentWeek) {
          return true;
        }

        // Include biweekly sessions (A/B) for current week
        if (sched.week === "A" || sched.week === "B") {
          // Calculate current week number for A/B determination
          const currentWeekNumber = Math.floor(
            (startOfWeek - new Date(startOfWeek.getFullYear(), 0, 1)) /
              (7 * 24 * 60 * 60 * 1000)
          );
          const isCurrentWeekA = currentWeekNumber % 2 === 0;

          // Include A/B sessions that match current week
          if (isInCurrentWeek) {
            return (
              (sched.week === "A" && isCurrentWeekA) ||
              (sched.week === "B" && !isCurrentWeekA)
            );
          }
        }

        return false;
      });

      //margin top of the page
      let top = 50;

      const cellToDelete = {};

      let timesHeader = [];
      for (let i = 0; i < times.length - 1; i++) {
        timesHeader[i] = {
          content: times[i] + " - " + times[i + 1],
          styles: {
            halign: "center",
            valign: "middle",
            lineWidth: 0.05,
          },
          colSpan: 4,
        };
      }

      for (let dayNumber = 0; dayNumber < days.length; dayNumber++) {
        const array = [new Array(40).fill(null)];
        const processedSessions = new Set(); // Track processed sessions to avoid duplicates

        for (let i = 0; i < times.length - 1; i++) {
          let schedules = filteredSchedules.filter((el) => {
            // Create unique session identifier
            const sessionId = `${el._id || el.id || "unknown"}_${el.day}_${
              el.time
            }`;

            // Skip if already processed
            if (processedSessions.has(sessionId)) {
              return false;
            }

            // Handle both new Date format and legacy numeric format
            let sessionDayNumber;
            if (el.day instanceof Date || typeof el.day === "string") {
              // New format: day is a specific date, get day of week
              const sessionDate = new Date(el.day);
              sessionDayNumber = sessionDate.getDay() - 1; // Convert to 0-6 (Monday=0)
              if (sessionDayNumber < 0) sessionDayNumber = 6; // Handle Sunday
            } else {
              // Legacy format: day is already a number
              sessionDayNumber = el.day;
            }

            // Check if session is on the correct day
            if (sessionDayNumber !== dayNumber) {
              return false;
            }

            // Parse session time and time slot
            const sessionTime = el.time ? el.time.split(":") : ["0", "0"];
            const sessionHour = parseInt(sessionTime[0]) || 0;
            const sessionMinute = parseInt(sessionTime[1] || 0) || 0;

            const timeSlotStart = times[i].split(":")[0];
            const timeSlotEnd = times[i + 1].split(":")[0];
            const slotStartHour = parseInt(timeSlotStart);
            const slotEndHour = parseInt(timeSlotEnd);

            // Convert session time to minutes for easier comparison
            const sessionTimeInMinutes = sessionHour * 60 + sessionMinute;
            const slotStartInMinutes = slotStartHour * 60;
            const slotEndInMinutes = slotEndHour * 60;

            // Check if session starts within this time slot OR if session spans this time slot
            // Duration is now in minutes (1 slot = 1 minute)
            const sessionDuration = el.duration || 60; // Default to 60 minutes (1 hour) if duration not specified
            const sessionEndTimeInMinutes =
              sessionTimeInMinutes + sessionDuration; // Duration already in minutes

            const isInTimeSlot =
              (sessionTimeInMinutes >= slotStartInMinutes &&
                sessionTimeInMinutes < slotEndInMinutes) ||
              // Session spans this time slot
              (sessionTimeInMinutes < slotStartInMinutes &&
                sessionEndTimeInMinutes > slotStartInMinutes);

            return isInTimeSlot;
          });
          schedules.forEach((sched) => {
            // Mark session as processed to avoid duplicates
            const sessionId = `${sched._id || sched.id || "unknown"}_${
              sched.day
            }_${sched.time}`;
            processedSessions.add(sessionId);
            // Handle new data structure - use moduleGeneral if available, otherwise subject
            const schedName = sched.moduleGeneral
              ? sched.moduleGeneral.name
              : sched.subject
              ? sched.subject.name
              : sched.name || "Unknown Subject";

            let cellValue =
              (sched.name ? sched.name : schedName) +
              "\r\n" +
              sched.teacher.employee.firstName +
              " " +
              sched.teacher.employee.lastName +
              "\r\n" +
              sched.classeRoom.name;

            // Add group information if exists
            if (sched.group && sched.group.name) {
              cellValue +=
                "\r\n" +
                getTranslation("schedule.group") + ": " +
                sched.group.name;
            }

            // Add week information if exists
            if (sched.week && (sched.week === "A" || sched.week === "B")) {
              const weekTranslation = sched.week === "A"
                ? getTranslation("schedule.weekA")
                : getTranslation("schedule.weekB");
              cellValue +=
                "\r\n" +
                getTranslation("schedule.week") + ": " +
                weekTranslation;
            }

            // Add cancellation indicator if session is canceled
            if (sched.canceled) {
              const canceledLabel = lang === "ar" ? "❌ ملغي" : "❌ CANCELLED";
              cellValue += "\r\n" + canceledLabel;
              if (sched.cancellationReason) {
                cellValue += "\r\n" + sched.cancellationReason;
              }
            }

            // get the time position ex: H:00 -> 0, H:15 -> 1, H:30 -> 2, H:45 -> 3
            let position = this.getPosition(sched.time);

            // For sessions with the same start time, always place them in new rows
            // Check if there are already sessions at this exact time slot
            const existingSessionsAtTime = array.filter(
              (row) =>
                row[i * 4 + position] !== null &&
                row[i * 4 + position] !== undefined
            );

            const sessionDurationMinutes = sched.duration || 60;
            const durationSlots = Math.ceil(sessionDurationMinutes / 15);

            let row;
            if (existingSessionsAtTime.length > 0) {
              // If there are already sessions at this time, add a new row
              array.push(new Array(40).fill(null));
              row = array.length - 1;
            } else {
              // Check for available row only if no sessions exist at this time
              row = array.findIndex((row) =>
                this.availableRow(row, i * 4 + position, durationSlots)
              );
              // else add new one
              if (row === -1) {
                array.push(new Array(40).fill(null));
                row = array.length - 1;
              }
            }

            // add the sched to the selected row
            const fontSize =
              sessionDurationMinutes <= 30
                ? 8 // Smaller font for sessions 30 minutes or less
                : 10;

            array[row][i * 4 + position] = {
              content: cellValue,
              styles: {
                halign: "center",
                valign: "middle",
                fontSize: fontSize,
              },
              colSpan: durationSlots,
            };

            // for fixing colspans
            for (let t = 1; t < durationSlots; t++)
              array[row][i * 4 + position + t] = cellToDelete;
          });
        }

        // fix table's colspans
        for (let row = 0; row < array.length; row++) {
          array[row] = array[row].filter((cell) => cell !== cellToDelete);
        }

        if (dayNumber != 0) {
          doc.addPage();
          top = 10;
        }
        doc.autoTable({
          theme: "grid",
          head: [
            [
              {
                content: days[dayNumber],
                colSpan: 10 * 4,
                styles: {
                  halign: "center",
                  fillColor: "#169c80",
                  fontSize: lang == "ar" ? 17 : 15,
                  textColor: "#ffffff",
                },
              },
            ],
            timesHeader,
          ],
          body: array,
          styles: { font: "Amiri" },
          margin: { top: top },
          columnStyles: {
            0: { cellWidth: 6.5 },
            1: { cellWidth: 6.5 },
            2: { cellWidth: 6.5 },
            3: { cellWidth: 6.5 },
            4: { cellWidth: 6.5 },
            5: { cellWidth: 6.5 },
            6: { cellWidth: 6.5 },
            7: { cellWidth: 6.5 },
            8: { cellWidth: 6.5 },
            9: { cellWidth: 6.5 },
            10: { cellWidth: 6.5 },
            11: { cellWidth: 6.5 },
            12: { cellWidth: 6.5 },
            13: { cellWidth: 6.5 },
            14: { cellWidth: 6.5 },
            15: { cellWidth: 6.5 },
            16: { cellWidth: 6.5 },
            17: { cellWidth: 6.5 },
            18: { cellWidth: 6.5 },
            19: { cellWidth: 6.5 },
            20: { cellWidth: 6.5 },
            21: { cellWidth: 6.5 },
            22: { cellWidth: 6.5 },
            23: { cellWidth: 6.5 },
            24: { cellWidth: 6.5 },
            25: { cellWidth: 6.5 },
            26: { cellWidth: 6.5 },
            27: { cellWidth: 6.5 },
            28: { cellWidth: 6.5 },
            29: { cellWidth: 6.5 },
            30: { cellWidth: 6.5 },
            31: { cellWidth: 6.5 },
            32: { cellWidth: 6.5 },
            33: { cellWidth: 6.5 },
            34: { cellWidth: 6.5 },
            35: { cellWidth: 6.5 },
            36: { cellWidth: 6.5 },
            37: { cellWidth: 6.5 },
            38: { cellWidth: 6.5 },
            39: { cellWidth: 6.5 },
          },
          headStyles: {
            valign: "middle",
            halign: "center",
            fontSize: 10,
            fontStyle: "bold",
          },
        });
      } // End of dayNumber loop

      //page numbering
      const pages = doc.internal.getNumberOfPages();
      const pageWidth = doc.internal.pageSize.width;
      const pageHeight = doc.internal.pageSize.height;
      doc.setFontSize(8); //Optional

      for (let j = 1; j < pages + 1; j++) {
        let horizontalPos = pageWidth / 2;
        let verticalPos = pageHeight - 10;
        doc.setPage(j);
        doc.text(getTranslation("pdf.pageNumber", { current: j, total: pages }), horizontalPos, verticalPos, {
          align: "center",
        });
      }

      this.loading = false;

      //end page numbering
      const pdfTitle = getTranslation("emploi.pdfEmploiAdmin");
      doc.save(`${pdfTitle}.pdf`);
    },
  },
  data() {
    return {
      data: [],
      loading: false,
    };
  },
};
</script>
